export const DEFAULT_FORM_LANGUAGE_CODE = "0000";
